
export default {
  getCurrentTime: state => {
    return state.currentTime;
  },
  getVesselPositions: state => {
    return state.vesselPositions.asImmutable();
  },
  getVesselInfos: state => {
    return state.vesselInfos.asImmutable();
  },
  getFeaturesForPoint: state => {
    return state.featuresForPoint.asImmutable();
  },
  getFeaturesForVector: state => {
    return state.featuresForVector.asImmutable();
  },
  getFeaturesForPolygon: state => {
    return state.featuresForPolygon.asImmutable();
  }
}
